import { render, staticRenderFns } from "./MYP102P01.vue?vue&type=template&id=849c160e&scoped=true&"
import script from "./MYP102P01.vue?vue&type=script&lang=js&"
export * from "./MYP102P01.vue?vue&type=script&lang=js&"
import style0 from "./MYP102P01.vue?vue&type=style&index=0&id=849c160e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "849c160e",
  null
  
)

export default component.exports